import { useMemo } from 'react';
import CustomStore from 'devextreme/data/custom_store';

import { apiInstance } from '../context/api';

export interface LookupItem {
  id: number | null;
  accountId: number | null;
  userLogin: string | null;
  userAccount: string | null;
  userEmail: string | null;
  userName : string | null;
}

const allUsersObject: any = {};

export function useUsersLookupStore(pageSize = 10) {
  const store = useMemo(
    () =>
      new CustomStore<LookupItem>({
        key: 'id',
        load: async ({ skip = 0, take = pageSize, searchValue }) => {
          const currentPage = skip / take + 1;
          const params: Record<string, any> = {
            itemsPerPage: take,
            currentPage,
            sort: 'userLogin',
          };
          if (searchValue) {
            params.search = searchValue;
          }

          const response: {
            status: string;
            pageData: {
              pages: number;
              currentPage: number;
              total: number;
              itemsPerPage: number;
            };
            userListData: LookupItem [];
          } = await apiInstance.get('/user-list', { params });

          return {
            data: response.userListData,
            totalCount: response.pageData.total,
          };
        },
        byKey: async (key: number) => {
          const user = allUsersObject[key];
          return new Promise(
            resolve => resolve({
              id: user.id,
              accountId: user.id,
              userLogin: user.userLogin,
              userAccount: user.userAccount,
              userEmail: user.userEmail,
              userName : user.userName,
            })
          )

          // const response: {
          //   status: string;
          //   data: { user: any }
          // } = await apiInstance.get(`/users/edit/${key}`);
          //
          // return {
          //   id: response.data.user.id,
          //   accountId: null,
          //   userLogin: response.data.user.wd_login,
          //   userAccount: null,
          //   userEmail: null,
          //   userName : null,
          // };
        }
      }),
    [pageSize]
  );

  return store
}
